const DEVICE_ID_KEY = 'cx_data_device_id';

export class DeviceIdHelper {
	static getOrCreateDeviceId(): string {
		let deviceId = localStorage.getItem(DEVICE_ID_KEY);
		
		if (!deviceId) {
			deviceId = this.generateDeviceId();
			localStorage.setItem(DEVICE_ID_KEY, deviceId);
		}
		
		return deviceId;
	}

	private static generateDeviceId(): string {
		const timestamp = Date.now();
		const random = Math.random().toString(36).substring(2, 15);
		return `${timestamp}-${random}`;
	}
}

